/**
 * ContactSection — email + phone.  Required for onboarding follow-up.
 *
 *   • Phone field auto-detects the area code as the user types and shows a
 *     friendly region hint underneath ("📍 New Hampshire").
 */
import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { EnvelopeSimple, Phone, MapPin } from '@phosphor-icons/react';
import { Field, TextInput } from './primitives';
import { regionForAreaCode } from './areaCodes';

export function ContactSection({ form, setEvt, isLight }) {
  const digits = (form.phone || '').replace(/\D/g, '');
  const region = regionForAreaCode(digits);
  return (
    <div className="space-y-4" data-testid="section-contact">
      <Field label="Email address" required icon={<EnvelopeSimple size={11} weight="fill" />} testId="field-email"
        hint="We'll send next-step info here.">
        <TextInput type="email" value={form.email} onChange={setEvt('email')} placeholder="you@example.com" autoComplete="email" isLight={isLight} testId="input-email" />
      </Field>
      <Field label="Phone number" required icon={<Phone size={11} weight="fill" />} testId="field-phone">
        <TextInput type="tel" value={form.phone} onChange={setEvt('phone')} placeholder="(555) 123-4567" autoComplete="tel" isLight={isLight} testId="input-phone" />
        <AnimatePresence>
          {region && (
            <motion.div
              key={region}
              initial={{ opacity: 0, y: -4 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -4 }}
              transition={{ duration: 0.25 }}
              className="inline-flex items-center gap-1.5 mt-1.5 text-[11px] font-black px-2.5 py-1 rounded-full"
              style={{
                background: 'linear-gradient(135deg, #F59E0B22, #CD040B22)',
                border: '1px solid rgba(245,158,11,0.45)',
                color: '#F59E0B',
              }}
              data-testid="phone-region-hint">
              <MapPin size={10} weight="fill" /> {region}
            </motion.div>
          )}
        </AnimatePresence>
      </Field>
    </div>
  );
}
